module.exports = __webpack_public_path__ + "img/facebook.e645ea4e.svg";